import React from 'react'
import {
  PROJECT_STATUS,
  PREDICTOR_STATUS,
  DATASET_STATUS,
  FOLDER_STATUS,
} from 'app/constants'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import TimelapseIcon from '@mui/icons-material/Timelapse'
import ErrorIcon from '@mui/icons-material/Error'
import CancelIcon from '@mui/icons-material/Cancel'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { red, orange, green } from '@mui/material/colors'
import { MatxTooltip } from '..'

import CircularProgressWithLabel from '../CircularProgressWithLabel'
import { useStore } from 'app/store'
import { observer } from 'mobx-react'


const getStatusIcon = (status, size, progress, trackProgress) => {
  switch (status) {
    case PREDICTOR_STATUS.TRAINING:
    case PROJECT_STATUS.RUNNING:
    case DATASET_STATUS.PREPARING_IN_AI:

    case PROJECT_STATUS.CANCELING:
    case PREDICTOR_STATUS.CANCELING:
    case PROJECT_STATUS.DELETING:
    case PREDICTOR_STATUS.DELETING:
      if (trackProgress) {
        return (
          <div className="flex">
            <CircularProgressWithLabel
              fontSize={size * 0.35}
              size={size}
              value={progress}
            />
          </div>
        )
      } else {
        return (
          <TimelapseIcon
            style={{ color: orange[500], width: size, height: size }}
          />
        )
      }

    case DATASET_STATUS.PREPARING:

      return (
        <TimelapseIcon
          style={{ color: orange[500], width: size, height: size }}
        />
      )
    case PREDICTOR_STATUS.COMPLETE:
    case PROJECT_STATUS.COMPLETE:
    case DATASET_STATUS.COMPLETED:
    case FOLDER_STATUS.CREATED:
      return (
        <CheckCircleIcon
          style={{ color: green[500], width: size, height: size }}
        />
      )
    case DATASET_STATUS.FAILED:
    case PROJECT_STATUS.FAILED:
    case PREDICTOR_STATUS.FAILED:
      return (
        <ErrorIcon style={{ color: red[500], width: size, height: size }} />
      )
    case DATASET_STATUS.CANCELING:
    case DATASET_STATUS.DELETING:
    case FOLDER_STATUS.DELETING:
      return (
        <CancelIcon style={{ color: orange[500], width: size, height: size }} />
      )
    case PROJECT_STATUS.CANCELED:
    case PREDICTOR_STATUS.CANCELED:
    case FOLDER_STATUS.DELETED:
      return (
        <CancelIcon style={{ color: red[500], width: size, height: size }} />
      )
    default:
      return <FiberManualRecordIcon style={{ width: size, height: size }} />
  }
}


function StatusIcon({ status, size = 30, objectType, objectId, trackProgress }) {
  const { objectsProgressStore } = useStore()
  const progress =
    objectsProgressStore.objectsProgress[objectType]?.[objectId]
      ?.percentCompleted || 0

  if (!status) return <></>

  const getTooltip = () => {
    switch (status) {
      case PREDICTOR_STATUS.TRAINING:
      case PROJECT_STATUS.RUNNING:
      case DATASET_STATUS.PREPARING:
      case DATASET_STATUS.PREPARING_IN_AI:
        if(trackProgress){
          return `${status}: ${progress}%`
        }
        return status;
      default:
        return status
    }
  }

  return (
    <MatxTooltip title={getTooltip()}>
      {getStatusIcon(status, size, progress, trackProgress)}
    </MatxTooltip>
  )
}

export default observer(StatusIcon)
